import { BlocksGalleryType, GalleryBlock } from '../galleryBlock/GalleryBlock';
import { BlocksMediaType, MediaBlock } from '../mediaBlock/MediaBlock';
import { BlocksMixedType, MixedBlock } from '../mixedBlock/MixedBlock';
import { BlocksTextType, TextBlock } from '../textBlock/TextBlock';
import { BlockCompareType, CompareBlock } from '../compareBlock/CompareBlock';

export type DefaultBlockProps = {
  image_height: number;
  image_width: number;
  image: string;
  phone_image_height?: number;
  phone_image_width?: number;
  phone_image?: string;
  video?: string;
  phone_video?: string;
  alt_text: string;
  autoplay: boolean;
  controls: boolean;
  loop: boolean;
  text_position: 'left' | 'right';
  text: string;
};

export type BlockType = BlocksMediaType | BlocksTextType | BlocksGalleryType | BlocksMixedType | BlockCompareType;
export type Props = { block: BlockType };
export const SwitchBlock = ({ block }: Props): JSX.Element => {
  switch (block.block_type) {
    // image and or video
    case 'media':
      return <MediaBlock {...block} />;
    case 'text':
      return <TextBlock {...block} />;
    case 'mixed':
      return <MixedBlock {...block} />;
    case 'gallery':
      return <GalleryBlock {...block} />;
    case 'compare':
      return <CompareBlock {...block} />;

    default:
      // this part of the code should be unreachable!
      return <p>an unkown block type.</p>;
  }
};
